import axios from 'axios';

const api = axios.create({
  baseURL: 'https://stockpilot-api-production.up.railway.app/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Auth
export const loginUser = (data) => api.post('/auth/login', data);
export const registerUser = (data) => api.post('/auth/register', data);
export const verifyEmail = (data) => api.post('/auth/verify-email', data);
export const changePassword = (data) => api.put('/auth/change-password', data);
export const getStaff = () => api.get('/auth/staff');
export const forgotPassword = (data) => api.post('/auth/forgot-password', data);
export const resetPassword = (data) => api.post('/auth/reset-password', data);

// Products
export const getProducts = () => api.get('/products');
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/products/${id}`);

// Sales
export const getSales = () => api.get('/sales');
export const createSale = (data) => api.post('/sales', data);
export const editSale = (id, data) => api.put(`/sales/${id}`, data);
export const voidSale = (id) => api.delete(`/sales/${id}`);
export const getSummary = () => api.get('/sales/summary');